import { WorkoutMode } from '@kinomap-dev/ng-ui-lib/core';

export const DEFAULT_TICKS_COUNT: number = 4;

export const WORKOUT_MODE_TICKS_COUNT: Readonly<Record<WorkoutMode, number>> = {
  ftp: 4,
  res: 4,
  inc: 5,
  slope: 5,
  watts: 5,
  spd: 5,
  incSpd: 4,
};

/** Temps en seconde -> 180s = 3min */
export const MINIMAL_WORKOUT_DURATION: number = 180;

export const MAX_TIME_TICKS: number = 6;
export const MIN_TICK_SPACING_PERCENT: number = 8;
/** Ecart minimal entre deux libelles de l'axe du temps, en px : evite qu'ils se chevauchent sur un graphe etroit. */
export const MIN_TICK_SPACING_PX: number = 48;
export const TIME_TICK_INTERVALS: readonly number[] = [
  5, 10, 15, 30, 60, 120, 300, 600, 900, 1800, 3600,
];
